import LocalizationStore from '../Stores/LocalizationStore'
import { AjvError } from 'react-jsonschema-form'

const ls = LocalizationStore.getInstance()

export function getRecoveryPasswordFormSchema(email: string, code: string): any {
    code = decodeURIComponent(code)
    return {
        'title': ls.t!('Trouble signing in?'),
        'type': 'object',
        'required': [
            'email',
            'password',
            'confirmPassword',
            'code'
        ],
        'properties': {
            email: {
                'title': ls.t('Enter e-mail'),
                'type': 'string',
                default: email
            },
            password: {
                'title': ls.t!('newPassword'),
                'type': 'string'
            },
            confirmPassword: {
                'title': ls.t!('confirmPassword'),
                'type': 'string'
            },
            code: {
                'title': ls.t!('token'),
                'type': 'string',
                default: code
            }
        }
    }
}

export const UIRecoveryPasswordFormSchema = {
    email: {
        'ui:readonly': true
    },
    code: {
        'ui:widget': 'hidden'
    }
}

export function transformErrors(errors: Array<AjvError>) {
    return errors.map((error: AjvError) => {
        if (error['property'] === '.email') {
            error['message'] = ls.t('Wrong email')
        }
        return error
    })
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/RecoveryPasswordForm.tsx